import { combineReducers } from 'redux'
import view from './View/reducer'
import partnerSiteSelection from 'containers/Product/ProductMappingTable/reducer'
import productSpecsSelection from 'containers/Product/ModifySpecifications/reducer'
import fulcrumTestSuiteSelection from 'containers/Product/FulcrumTestSuiteConfiguration/reducer'
import {
  productReducer as product,
  formElementReducer as elements,
} from 'containers/ProductOverview/reducer'
import {
  productRolesReducer as productSupportTeam,
  productRolesChangeReducer as productSupportTeamChanges,
  editReducer as edit
} from 'containers/Product/SupportTeam/reducer'


export default combineReducers({
  product,
  elements,
  view,
  partnerSiteSelection,
  productSpecsSelection,
  fulcrumTestSuiteSelection,
  productSupportTeam,
  productSupportTeamChanges,
  edit

})
